import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';
import {Moment} from 'moment';

export class RDate extends BaseModel {
	public UTCDate: Moment;
	public localDate: Moment;
	public databaseDate: string;

	constructor(public tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public deserialize(date: any = moment().utc(), type = 'UTC', format?: string, localDateTenantTZ: boolean = false): this {
		if (type === 'UTC') {
			this.UTCDate = moment.utc(date);
		}
		if (type === 'localDate') {
			if (format) {
				switch (format) {
					case 'HH:mm':
						const tempDate = (localDateTenantTZ)
							? moment.tz(this.tenantTZ).format('YYYY-MM-DD')
							: moment().format('YYYY-MM-DD');
						date = tempDate + ' ' + date + ':00';
						this.UTCDate = (localDateTenantTZ)
							? moment.tz(date, this.tenantTZ).utc()
							: moment(date).utc();
						break;
					default:
						this.UTCDate = (localDateTenantTZ)
							? moment.tz(date, format, this.tenantTZ).utc()
							: moment(date, format).utc();
						break;
				}
			} else {
				this.UTCDate = (localDateTenantTZ)
					? moment.tz(date, this.tenantTZ).utc()
					: moment(date).utc();
			}
		}
		this.localDate = (localDateTenantTZ)
			? moment.utc(this.UTCDate).tz(this.tenantTZ)
			: moment.utc(this.UTCDate).local();

		this.databaseDate = this.UTCDate.clone().toISOString();

		return this;
	}

	public formatWithoutYear(date, year): string {
		const yearReg = new RegExp('\\-?\\/?(\\s)?,?(\\s)?' + year + '(\\.)?(\\,)?');

		return date.replace(yearReg, '');
	}

	public format(format = 'short', endRDate?: RDate, uppercaseFirst = true, useUTCDates = false, removeCurrentYear = false): string {
		const index = (useUTCDates) ? 'UTCDate' : 'localDate';

		const startDate = this[index];
		let endDate;
		if (endRDate) {
			endDate = endRDate[index];
		}

		const today = moment();
		let formattedFirstDate, formattedLastDate, displayEndDate;
		switch (format) {
			case 'short':
				if (today.diff(startDate, 'days') <= 6) {// eg. last friday at 14:00 pm
					formattedFirstDate = startDate.calendar();
				} else {
					formattedFirstDate = startDate.format('lll');
				}
				removeCurrentYear = true;
				break;
			case 'short-daterange':
				const endTimeGtStartTime = (parseInt(endDate.format('HH:mm')) > parseInt(startDate.format('HH:mm')));
				displayEndDate = (startDate.diff(endDate, 'days') > 0 && !endTimeGtStartTime);

				const diffStartDays = today.diff(startDate, 'days');
				formattedFirstDate = (diffStartDays >= -6 && diffStartDays <= 6)
					? startDate.calendar()
					: startDate.format('lll');

				if (displayEndDate) {
					const diffEndDays = today.diff(endDate, 'days');
					formattedLastDate = (diffEndDays >= -6 && diffEndDays <= 6)
						? ' - ' + startDate.calendar()
						: ' - ' + startDate.format('lll');
				}

				if (!displayEndDate) {
					formattedLastDate = ' - ' + endDate.format('LT');
				}

				removeCurrentYear = true;
				break;
			case 'date':
				formattedFirstDate = startDate.format('ll');
				removeCurrentYear = true;
				break;
			case 'date-diff':
				displayEndDate = (endDate.diff(startDate, 'days') > 0);
				formattedFirstDate = startDate.format('ll');
				if (displayEndDate) {
					formattedLastDate = ' - ' + endDate.format('ll');
				}
				removeCurrentYear = true;
				break;
			case 'num-date':
				formattedFirstDate = startDate.format('L');
				removeCurrentYear = true;
				break;
			case 'num-date-diff':
				displayEndDate = (endDate.diff(startDate, 'days') > 0);
				formattedFirstDate = startDate.format('L');
				if (displayEndDate) {
					formattedLastDate = ' - ' + endDate.format('L');
				}
				removeCurrentYear = true;
				break;
			case 'num-date-time':
				formattedFirstDate = startDate.format('L') + ' ' + startDate.format('LT');
				removeCurrentYear = true;
				break;
			default:
				formattedFirstDate = startDate.format(format);
				break;
		}
		if (removeCurrentYear && startDate.year() === today.year()) {
			formattedFirstDate = this.formatWithoutYear(formattedFirstDate, startDate.year());
		}
		if (uppercaseFirst) {
			formattedFirstDate = formattedFirstDate.charAt(0).toUpperCase() + formattedFirstDate.slice(1);
		}
		if (formattedLastDate) {
			if (removeCurrentYear && endDate.year() === today.year()) {
				formattedLastDate = this.formatWithoutYear(formattedLastDate, startDate.year());
			}
			formattedFirstDate += formattedLastDate;
		}

		return formattedFirstDate;
	}
}
